import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const session_rescheduleScreenModule = defineScreen({
  app: "coaching",
  screen_id: "session-reschedule",
  path: "/sessions/:session_id/reschedule",
  params: ["session_id"],
  heading: { text: "Reschedule session", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/session-reschedule.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default session_rescheduleScreenModule;
